export const SIGNIN_MODAL_CONST = {
    containerId: "mng-signin-modal",
    visibleClass: "mng-signin-modal-visible",
    bodyOpenClass: "mng-signin-modal-open",
    logoSelector: ".mng-signin-modal-logo",
    subHeaderSelector: ".mng-signin-modal-subheader",
    providerSelector: "[data-mng-signin-provider]",
    closeSelector: "[data-mng-signin-action='close']",
    appleProvider: "apple",
    googleProvider: "google-oauth2",
    defaultSubHeaderText: "Sign in with your account.",
    // How long to wait for the auth pipeline to report before falling back to the cached Auth0 cache.
    authDeterminedTimeoutMs: 5000,
    gtmDisplayed: "one_tap_displayed",
    gtmClick: "one_tap_click",
    gtmDismissed: "one_tap_cancel",
} as const;
